// var szHeader = document.querySelector('.header');
// if (szHeader != undefined) {
//     headerHeight = szHeader.offsetHeight;
//     document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
// } else {
//     document.documentElement.style.setProperty('--header-height', `55px`);
// }

var megaMenuItems = document.querySelectorAll("[data-header-megamenu-item]");
var stickyHeader = document.querySelector("[data-header-sticky]");

megaMenuItems.forEach(item => {
    var container = item.querySelector("[data-header-megamenu-container]");
    item.addEventListener("mouseenter", () => {
        container.classList.add("open");
        if (stickyHeader && window.scrollY < 200) stickyHeader.classList.remove("reverse");
    });
    item.addEventListener("mouseleave", () => {
        container.classList.remove("open");
        if (stickyHeader && window.scrollY < 200) stickyHeader.classList.add("reverse");
    });
});

document.querySelector("[data-icon-hamburger]").addEventListener("click",() => {
    if (stickyHeader) {
        if (stickyHeader.classList.contains("reverse") && window.scrollY < 200) {
            stickyHeader.classList.remove("reverse")
        } else if (window.scrollY < 200) {
            stickyHeader.classList.add("reverse");
        }
    }
});

// Assurez-vous d'appeler cette fonction après que le DOM soit chargé.
function manageScrollClass() {
    // Remplacez 'elementId' par l'ID de l'élément sur lequel vous voulez travailler
    // Remplacez '.targetClass' par la classe que vous voulez supprimer/ajouter
    const element = document.querySelector('[data-header-sticky]');

    // Cette fonction vérifie la position de défilement et ajoute ou supprime la classe en conséquence
    function checkScrollPosition() {
        if (window.scrollY > 200 && element) {
            element.classList.remove('reverse');
        } else if (element && document.querySelectorAll(".mega-menu__content.open").length == 0) {
            element.classList.add('reverse');
        }
    }

    // Attachez la fonction de vérification à l'événement de défilement
    window.addEventListener('scroll', checkScrollPosition);
}

// Appelez la fonction une fois que le DOM est prêt
document.addEventListener('DOMContentLoaded', function() {
    manageScrollClass();
});